module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAc0lEQVQ4je2SMQ7AMAgD7SoP42eEn5GXuUOVSM0Utg71hJAObATwi5IAABGhKuzubBM2sxKcmSCpFhFy9xIcEatuADDGOAItDWn56l2VzTu8HABPpiMX263WgNM77HHb3H7qYKr3DkmkJJAs/4AkVpmP6gaJOjDeCiiLTwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/CDRIVE_16.png
// module id = 45
// module chunks = 0